import SetWinnerTable from './setWinnerTable.container'

export default SetWinnerTable